<template>
    <div class="stripe-return">{{ langJson('Returning to your event…') }}</div>
</template>
<script>
// Stripe's hosted onboarding sends the organiser back here (via the API's
// reconcile-then-redirect route). Show the outcome and land on the Stripe step.
const MESSAGES = {
    complete: ['success', 'Stripe is connected — you can now take payments'],
    pending: ['warning', 'Stripe still needs a few details — continue setup when you’re ready'],
    not_started: ['warning', 'Stripe setup hasn’t started yet'],
    error: ['error', 'We couldn’t check your Stripe status — please try again'],
}

export default {
    name: 'StripeReturnPage',
    created() {
        const { eventId, stripeOnboarding } = this.$route.query
        const message = MESSAGES[stripeOnboarding]
        if (message) this.pushMsg(message[0], this.langJson(message[1]))
        if (eventId) this.$router.replace({ path: '/brand/events/edit', query: { id: eventId, step: 'stripe' } })
        else this.$router.replace('/brand/events/index')
    },
}
</script>
<style lang="scss" scoped>
.stripe-return {
    padding: 96px 16px;
    text-align: center;
    font-family: 'Lato';
    color: var(--font_modif_color);
}
</style>
